<div class="mb-2 mat-title-small">{{ 'catalog.settings.result_title' | transloco }}</div>

<mat-slide-toggle
  (change)="tabsLockedChange.emit($event.checked)"
  [checked]="tabsLocked"
  class="primary-slide-toggle"
  id="search-result-list-tabs-locked-toggle"
>
  {{ 'catalog.settings.result_lock' | transloco }}
</mat-slide-toggle>
